import type { HttpInterceptorFn } from '@angular/common/http';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const token:string | null = localStorage.getItem('token');

  if (token) {
    req = req.clone({
      setHeaders: {
       Authorization: `Bearer ${token}`
      }
    })
  }
  return next(req);
};
